import React, { useMemo } from 'react';
import './BalanceOfPlay.css';
import { TeamColors } from '../../domain/entities';
import { parseColor, getContrast } from '../../utils/utilities';

interface BalanceBarProps {
    homeValue: number;
    awayValue: number;
    homeColor: string;
    awayColor: string;
}

const BalanceBar: React.FC<BalanceBarProps> = ({ homeValue, awayValue, homeColor, awayColor }) => {
    const total = homeValue + awayValue;
    const homePercent = total > 0 ? (homeValue / total) * 100 : 50;
    const awayPercent = total > 0 ? (awayValue / total) * 100 : 50;

    return (
        <div className="balance-bar">
            <div className="bar-segment home" style={{ width: `${homePercent}%`, backgroundColor: homeColor }}>
                <span className="bar-value">{Math.round(homeValue)}</span>
            </div>
            <div className="bar-segment away" style={{ width: `${awayPercent}%`, backgroundColor: awayColor }}>
                <span className="bar-value">{Math.round(awayValue)}</span>
            </div>
        </div>
    );
};


interface BalanceOfPlayProps {
    homeName: string;
    awayName: string;
    homeColors: TeamColors;
    awayColors: TeamColors;
    homeAttack: number;
    homeMid: number;
    homeDef: number;
    awayAttack: number;
    awayMid: number;
    awayDef: number;
}

export const BalanceOfPlay: React.FC<BalanceOfPlayProps> = (props) => {
    const { 
        homeName, awayName, homeColors, awayColors,
        homeAttack, homeMid, homeDef, 
        awayAttack, awayMid, awayDef
    } = props;

    const finalAwayColor = useMemo(() => {
        let color = awayColors.primary;
        const homeRgb = parseColor(homeColors.primary);
        const awayPrimaryRgb = parseColor(awayColors.primary);
    
        if (getContrast(homeRgb, awayPrimaryRgb) < 1.5) { // Threshold for "too similar"
            const awaySecondaryRgb = parseColor(awayColors.secondary);
            if (getContrast(homeRgb, awaySecondaryRgb) < 1.5) {
                color = 'var(--highlight-color)'; // Fallback color
            } else {
                color = awayColors.secondary;
            }
        }
        return color;
    }, [homeColors, awayColors]);

    return (
        <div className="balance-of-play-container">
            <h4>Balance of Play</h4>
            <div className="balance-row">
                <div className="balance-labels">
                    <span className="home-label">{homeName}</span>
                    <span className="zone-label">Attack vs Defence</span>
                    <span className="away-label">{awayName}</span>
                </div>
                <BalanceBar homeValue={homeAttack} awayValue={awayDef} homeColor={homeColors.primary} awayColor={finalAwayColor} />
            </div>

             <div className="balance-row">
                <div className="balance-labels">
                    <span className="home-label">{homeName}</span>
                    <span className="zone-label">Midfield Battle</span>
                    <span className="away-label">{awayName}</span>
                </div>
                <BalanceBar homeValue={homeMid} awayValue={awayMid} homeColor={homeColors.primary} awayColor={finalAwayColor} />
            </div>

            <div className="balance-row">
                <div className="balance-labels">
                    <span className="home-label">{homeName}</span>
                    <span className="zone-label">Defence vs Attack</span>
                    <span className="away-label">{awayName}</span>
                </div>
                <BalanceBar homeValue={homeDef} awayValue={awayAttack} homeColor={homeColors.primary} awayColor={finalAwayColor} />
            </div>
        </div>
    );
};